/**
 * Extracts a seed entity from a /my API response.
 *
 * Seeds are stored as assets or webapplications in the backend,
 * so the response can contain the entity under different keys.
 * Also handles both array and object response formats.
 */
export function extractSeedFromResponse(
  data: Record<string, unknown>
): unknown {
  for (const key of ['assets', 'webapplications', 'seeds']) {
    const items = data[key];
    if (Array.isArray(items) && items.length > 0) return items[0];
    if (items && typeof items === 'object' && !Array.isArray(items)) {
      const values = Object.values(items);
      if (values.length > 0) return values[0];
    }
  }
  return undefined;
}
